import { Header } from '../../../components/pagesComponents/administrativePanelPage/header'
import { SideBar } from '../../../components/pagesComponents/administrativePanelPage/sideBar'
import { Coupons } from '../../../components/pagesComponents/administrativePanelPage/coupons'
import { Dashboard } from '../../../components/pagesComponents/administrativePanelPage/dashboard'
import { CoverPage } from '../../../components/pagesComponents/administrativePanelPage/coverPage'
import { CentralizedModal } from '../../../components/pagesComponents/administrativePanelPage/centralizedModal'
import { Home } from '../../../components/pagesComponents/administrativePanelPage/home'
import { Clube } from '../../../components/pagesComponents/administrativePanelPage/clube'
import { Orders } from '../../../components/pagesComponents/administrativePanelPage/Orders'
import { Sales } from '../../../components/pagesComponents/administrativePanelPage/sales'
import { CurveAbc } from '../../../components/pagesComponents/administrativePanelPage/curveAbc'
import { Goals } from '../../../components/pagesComponents/administrativePanelPage/goals'
import { CurveAbcProducts } from '../../../components/pagesComponents/administrativePanelPage/CurveAbcProducts'

import { FilteredInformations } from '../../../components/pagesComponents/administrativePanelPage/filteredInformations'
import { MainLoader } from '../../../components/loaders/mainLoader'
import { MonthlyBilling } from '../../../components/pagesComponents/administrativePanelPage/monthlyBilling';
import { SalesChannelBilling } from '../../../components/pagesComponents/administrativePanelPage/salesChannelBilling';
import {PersonLine} from '../../../components/pagesComponents/administrativePanelPage/personLine';

import { Provider } from 'react-redux'
import { store } from '../store'
import { useAdministrativeContext } from '../administrativePanelContext'

import { Container } from './style'


export function AdmPanelContent() {
    const { isLoading, informationsToShowInPage } = useAdministrativeContext()

    if(isLoading){
        return <MainLoader title="Preparando tudo"/>
    }
    else
        return(
            <Container>
                
                <Header/>

               
                <Provider store={store}>
                    <FilteredInformations />
                  
                    {
                        informationsToShowInPage === 'coupons' ?
                            <Coupons  />
                        : informationsToShowInPage === 'dashboard' ?
                            <Dashboard />
                        : informationsToShowInPage === 'home' ?
                            <Home />
                        : informationsToShowInPage === 'clube' ?
                            <Clube />
                        : informationsToShowInPage === 'ordersSummary' ?
                            <Orders />
                        : informationsToShowInPage === 'sales'?
                            <Sales/>
                        : informationsToShowInPage === 'curveAbc'?
                            <CurveAbc/>
                        : informationsToShowInPage === 'goals'?
                            <Goals/>
                        : informationsToShowInPage === 'products' ?
                            <CurveAbcProducts/>
                        :
                        informationsToShowInPage === 'monthlyBilling' ?
                            <MonthlyBilling/>
                        :
                        informationsToShowInPage === 'salesChannelBilling' ?
                            <SalesChannelBilling/>
                        :
                        informationsToShowInPage === 'line' ?
                            <PersonLine/>    
                        :
                        <></>
                    }


                    <CentralizedModal />


                    <SideBar /> 
                

                    <CoverPage />

                </Provider>

            </Container>
        )
}